import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from 'routing'

import App from './App'
import './i18n'

function loadGoogleScript(): Promise<void> {
  return new Promise((resolve) => {
    if ((window as any).google?.accounts?.id) {
      resolve()
      return
    }

    const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]')
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve())
      return
    }

    const script = document.createElement("script")
    script.src = "https://accounts.google.com/gsi/client"
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    document.body.appendChild(script)
  })
}

loadGoogleScript().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <App>
      <RouterProvider router={router} />
    </App>
  )
})
